import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ThemeProvider } from './components/ThemeProvider';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Book } from './pages/Book';
import { Podcast } from './pages/Podcast';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Store } from './pages/Store';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { ExperienceNotation } from './pages/ExperienceNotation';
import { ExperienceEscapeRoomPage } from './pages/ExperienceEscapeRoomPage';

function ExternalRedirect({ url }: { url: string }) {
  useEffect(() => { window.location.replace(url); }, [url]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="hardcover" element={<ExternalRedirect url="https://www.amazon.com/dp/B0GNTY4RLD" />} />
          <Route path="softcover" element={<ExternalRedirect url="https://www.amazon.com/dp/B0GNVQRD9X" />} />
          <Route path="digital" element={<ExternalRedirect url="https://www.amazon.com/dp/B0GNTC5WVD" />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="book" element={<Book />} />
            <Route path="podcast" element={<Podcast />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:id" element={<BlogPost />} />
            <Route path="store" element={<Store />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<TermsOfUse />} />
            <Route path="experience" element={<ExperienceNotation />} />
            <Route path="escape" element={<ExperienceEscapeRoomPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
